module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Silver Aluminum + White Closed.d88ed785.png";